import * as auth from 'aws-amplify/auth';
import { useEffect, useState } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react-core";
import { notification } from "antd";
import { saveUserInfo } from 'helpers/auth';


const Authenticator = ({ children }) => {
    const { authStatus } = useAuthenticator();
    const [current_session, set_current_session] = useState(null)

    useEffect(() => {
        (async () => {
            try {
                if (authStatus !== 'authenticated') {
                    await auth.signInWithRedirect()
                }
                 else {
                    let session = await auth.fetchAuthSession()
                    console.log("session",session)
                    set_current_session(session)
                    await saveUserInfo(session)
                }
            } catch (e) {
                if(e instanceof auth.AuthError){
                    if(e.name === "UserAlreadyAuthenticatedException"){
                        return
                    }
                }
                notification.error({message: 'Error signing in, contact app admin ...'})
                console.error(e)
            }
        })()


    }, [authStatus])
    return <>{authStatus === 'authenticated' ? children : []}</>
}

export default Authenticator